<script lang="ts" setup>
import { onMounted } from 'vue'
import { brand, brandConfig } from '@/config/brands'

const props = defineProps<{
  clientId?: string
  slotId?: string
}>()

const ADSENSE_CLIENT_ID = props.clientId
  || import.meta.env.VITE_ADSENSE_CLIENT_ID
  || brandConfig.texts?.adsenseClientId
  || ''
const ADSENSE_SLOT_ID = props.slotId
  || import.meta.env.VITE_ADSENSE_SLOT_ID
  || brandConfig.texts?.adsenseSlotId
  || ''

onMounted(() => {
  // eslint-disable-next-line no-console
  console.log('[AdSense] mounted, brand=', brand, 'clientId=', ADSENSE_CLIENT_ID, 'slotId=', ADSENSE_SLOT_ID)

  if (brand !== 'rocnovel') {
    // eslint-disable-next-line no-console
    console.log('[AdSense] skip: brand is not rocnovel')
    return
  }
  if (!ADSENSE_CLIENT_ID || !ADSENSE_SLOT_ID) {
    // eslint-disable-next-line no-console
    console.log('[AdSense] skip: missing clientId or slotId')
    return
  }

  // eslint-disable-next-line no-console
  console.log('[AdSense] pushing to adsbygoogle...')
  try {
    (window.adsbygoogle = window.adsbygoogle || []).push({})
    // eslint-disable-next-line no-console
    console.log('[AdSense] push success, adsbygoogle=', window.adsbygoogle)
  }
  catch (e) {
    console.error('[AdSense] push error:', e)
  }
})
</script>

<template>
  <div v-if="brand === 'rocnovel' && ADSENSE_CLIENT_ID && ADSENSE_SLOT_ID" class="adsense-inline-article">
    <ins
      class="adsbygoogle"
      style="display:block; text-align:center;"
      data-ad-layout="in-article"
      data-ad-format="fluid"
      :data-ad-client="ADSENSE_CLIENT_ID"
      :data-ad-slot="ADSENSE_SLOT_ID"
    />
  </div>
</template>

<style lang="scss" scoped>
.adsense-inline-article {
  margin: 12px 0;
}

/* 当 AdSense 成功填充广告后，ins 元素会有内容，自然撑开高度 */
.adsense-inline-article :deep(ins.adsbygoogle[data-ad-status="filled"]) {
  display: block !important;
}
</style>
